import { createAction } from '@reduxjs/toolkit';
import {
  Engines,
  HistoryPage,
  SearchResponse,
  SearchTag,
  Suggestion,
  ThinksuggestData,
} from './types';

export const chooseEngine = createAction<Engines>('searchForm/chooseEngine');
export const setIsAutofocus = createAction<boolean>(
  'searchForm/setIsAutofocus'
);

export const showFeed = createAction<boolean>('searchForm/showFeed');

export const toggledInputFocus = createAction<boolean>(
  'searchForm/toggledInputFocus'
);
export const toggledChooseEngine = createAction<boolean>(
  'searchForm/toggledChooseEngine'
);
export const speechStarted = createAction('searchForm/speechStarted');
export const speechEnded = createAction('searchForm/speechEnded');
export const pressedEscape = createAction<boolean>('searchForm/pressedEscape');
export const suggestionNavigate = createAction<{
  id: string;
  inputType: 'keyboard' | 'preselected';
}>('searchForm/suggestionNavigate');
export const suggestionHover = createAction<string>(
  'searchForm/suggestionHover'
);

export const searchSubmitted = createAction<{
  term: string;
  gain: number;
  isAd: boolean;
  searchTag?: SearchTag;
  hintId: number;
}>('searchForm/searchSubmitted');

export const fetchedThinksuggestAds = createAction<{
  provided: string;
  term: string;
  suggestions: ThinksuggestData;
}>('searchForm/fetchedThinksuggestAds');
export const fetchedInstantResults = {
  pending: createAction<string>('searchForm/fetchedInstantResults/pending'),
  fulfilled: createAction<SearchResponse>(
    'searchForm/fetchedInstantResults/fulfilled'
  ),
  rejected: createAction<string>('searchForm/fetchedInstantResults/rejected'),
};

export const userTyping = createAction<{ inputType: string; term: string }>(
  'searchForm/userTyping'
);
export const fetchedSuggestions = createAction<{
  term: string;
  inputType: string;
  list: Suggestion[];
}>('searchForm/fetchedSuggestions');
export const removeSuggestion = createAction<string[]>(
  'searchForm/removeSuggestion'
);
export const discoveredCommand = createAction<chrome.commands.Command>(
  'searchForm/discoveredCommand'
);
export const searchTagSelected = createAction<string>(
  'searchForm/searchTagSelected'
);
